import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { benefits } from '../../data/content';
export function Benefits() {
  return <Section className="bg-white" aria-labelledby="beneficios-titulo" data-id="element-43" data-mp="c95n544kufi7">
      <Reveal data-id="element-44" data-mp="g9zbfylxlwbm">
        <SectionHeading id="beneficios-titulo" data-id="element-45" data-mp="g8eg46rsm9cp">Lo que va a cambiar en tu vida</SectionHeading>
      </Reveal>

      <ul className="mt-10 grid gap-x-12 gap-y-1 md:grid-cols-2" data-id="element-46" data-mp="3fpw9wuodp76l">
        {benefits.map((benefit, index) => <Reveal as="li" key={benefit.headline} delay={index * 0.04} className="list-none" data-id="element-47" data-mp="3kogy1vqcw0eo" data-mpi={index}>
            <div className="flex items-start gap-4 border-b border-mist py-4" data-id="element-48" data-mp="3oo7v2h6h7crn">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-forest" aria-hidden="true" data-id="element-49" data-mp="3tovp7bq049q3">
                <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} data-id="element-50" data-mp="13yiikat8w324" />
              </span>
              <p className="text-base leading-relaxed text-body" data-id="element-51" data-mp="18wk0gsexpwc0">
                <strong className="font-bold text-ink" data-id="element-52" data-mp="pdkie6cgk79t">{benefit.headline}</strong> — {benefit.detail}
              </p>
            </div>
          </Reveal>)}
      </ul>
    </Section>;
}